import { Box, Grid } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../../components/common/FormikControl";
import { useDispatch, useSelector } from "react-redux";
import { addLSMRejectionReason, editLSMRejectionReason, selectLSMRejectionReasonLoading } from "../../../slices/lsmRejectionReason";

const validationSchema = Yup.object().shape({
    name: Yup.string()
        .min(1, " Name must be between 1-50 characters long")
        .max(50," Name must be between 1-50 characters long")
        .required(" Name is required"),
    active: Yup.string().required("Status is required"),
});

const AddLSMRejectionReasonForm = ({ editData = null }) => {
    const dispatch = useDispatch()
    const isLoading = useSelector(selectLSMRejectionReasonLoading)
    const initialValues = {
        name: editData?.name ?? "",
        active: editData && !editData.active ? 0 : 1
    };

    const handleSubmit = async (values) => {
        if (editData) {
            await dispatch(editLSMRejectionReason({ data: { ...values, active: values.active.toString() }, editId: editData.id }))
        } else {
            await dispatch(addLSMRejectionReason({ ...values, active: values.active.toString() }))
        }
    }
    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: handleSubmit,
        enableReinitialize: true
    })

    const formOptions = [
        {
            label: 'Name',
            type: 'text',
            name: 'name',
            required: true,
            placeholder: "Enter name",
        },
        {
            label: 'Status',
            type: 'select',
            name: 'active',
            required: true,
            options: [
                { value: 1, label: "Active" },
                { value: 0, label: "In-Active" },
            ]
        },
    ];

    return (
        <Box>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2} className="mb-3">
                    {formOptions.map((props, key) => (
                        <Grid key={key} item xs={12}>
                            <FormikControl formik={formik} {...props} />
                        </Grid>
                    ))}
                </Grid>
                <Grid container spacing={2} className="mt-3">
                    <Grid item xs={12}>
                        <LoadingButton loading={isLoading} fullWidth type="submit" variant="contained">{editData ? "Update" : "Submit"}</LoadingButton>
                    </Grid>
                </Grid>
            </form>
        </Box>
    );
}

export default AddLSMRejectionReasonForm;